import { Icon, IconColor, IconName, IconSize, Margin } from '@snoam/pinata';
import * as React from 'react';

const styleClass = {
  icon: Margin.MX_AUTO
};

export interface ITopIconProps extends React.HTMLAttributes<HTMLDivElement> {
  iconName: IconName;
}

const TopIcon: React.FC<ITopIconProps> = props => (
  <Icon
    className={styleClass.icon}
    name={props.iconName}
    color={IconColor.POSITIVE}
    size={IconSize.XXLARGE}
  />
);

TopIcon.displayName = "TopIcon";

export default TopIcon;
